module.exports = __webpack_public_path__ + "media/images/icon-notice@3x-4de225d81b349c43deb78a6e44ca6d57.png";